import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rk-auto-generated',
  templateUrl: './auto-generated.component.html',
  styleUrls: ['./auto-generated.component.css']
})
export class AutoGeneratedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
